import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ActivityModel } from '../../../../../../core/models/activity.model';

@Component({
  selector: 'vex-building-unlink-warning',
  templateUrl: './building-unlink-warning.component.html',
})
export class BuildingUnlinkWarningComponent {
  activities: ActivityModel[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) data: { activities: ActivityModel[] },
    private dialogRef: MatDialogRef<BuildingUnlinkWarningComponent>,
  ) {
    this.activities = data.activities || [];
  }

  close() {
    this.dialogRef.close();
  }
}
